/**
* id.ts
* @author Ram Thiru (ramthi)
* @copyright Microsoft 2018
*/
import { createGuid, getCookie } from '@ms/1ds-core-js';
var Id = /** @class */ (function () {
    function Id() {
        this.appUserId = null;
        this.firstPageView = false;
        this.lastPageViewId = createGuid();
        this.traceId = this.createTraceId();
    }
    Id.prototype.createTraceId = function () {
        return createGuid().replace(/-/g, '');
    };
    Id.visitorId = function () {
        var userId = getCookie('MUID');
        return userId;
    };
    Id.prototype.getTraceId = function () {
        return this.traceId;
    };
    Id.prototype.getLastPageViewId = function () {
        return this.lastPageViewId;
    };
    Id.prototype.initializeIds = function () {
        if (!this.firstPageView) {
            this.firstPageView = true;
        }
        else {
            this.traceId = this.createTraceId();
            this.lastPageViewId = createGuid();
        }
    };
    Id.prototype.getMuidUserId = function () {
        var muidValue = getCookie('MUID');
        return muidValue && muidValue.length ? 't:' + muidValue : muidValue;
    };
    /// Set app user id.
    Id.prototype.setAppUserId = function (uid) {
        this.appUserId = null; // Make sure to reset the last user id.
        if (!uid) {
            return; // No need to log null or empty user ids which can be used to reset app user ids.
        }
        for (var i = 0; i < Id.userIdPrefixes.length; i++) {
            if (Id.userIdPrefixes[i] === uid.substring(0, 2)) {
                this.appUserId = uid;
                break;
            }
        }
        if (!this.appUserId) {
            // this._traceLogger.w('Unsupported app user id: ' + uid + '. Supported app user ids are: c:, i:, and w:');
        }
    };
    Id.prototype.setDeviceClass = function (newDeviceClass) {
        if (newDeviceClass) {
            this.deviceClass = newDeviceClass;
        }
    };
    Id.prototype.getDeviceClass = function () {
        return this.deviceClass;
    };
    Id.prototype.getAppUserId = function () {
        return this.appUserId;
    };
    // Limit support to i, w, and c; make logging accidental PII data more difficult.
    Id.userIdPrefixes = [
        'c:',
        'i:',
        'w:' // domain user id as hash
    ];
    return Id;
}());
export default Id;
//# sourceMappingURL=Id.js.map